(function(){
function shuffle(a){for(var i=a.length-1;i>0;i--){var j=Math.floor(Math.random()*(i+1));var t=a[i];a[i]=a[j];a[j]=t}return a}
function initShowcase(root){
  if(root.getAttribute('data-sk-init'))return;root.setAttribute('data-sk-init','1');
  var n=parseInt(root.getAttribute('data-cols'),10)||4,mode=root.getAttribute('data-mode')||'random';
  var iv=(parseFloat(root.getAttribute('data-interval'))||5)*1000,auto=root.getAttribute('data-auto')==='1';
  var pins={},pinHref={};
  [].forEach.call(root.querySelectorAll('.sk-pins > .sk-item'),function(p){var s=parseInt(p.getAttribute('data-slot'),10);if(s>=1&&s<=n&&!pins[s]){pins[s]=p;pinHref[p.getAttribute('href')]=1}});
  var pool=[];
  if(mode!=='manual'){[].forEach.call(root.querySelectorAll('.sk-pool > .sk-item'),function(p){if(!pinHref[p.getAttribute('href')])pool.push(p)})}
  var box=root.querySelector('.sk-slots');box.innerHTML='';
  var cells=[],free=[];
  for(var i=1;i<=n;i++){
    if(!pins[i]&&mode==='manual')continue;
    var c=document.createElement('div');c.className='sk-cell';box.appendChild(c);cells[i]=c;
    if(pins[i]){c.appendChild(pins[i].cloneNode(true))}else{free.push(i)}
  }
  var queue=[];
  function visible(){var v={};cells.forEach(function(c){if(c){var a=c.querySelector('.sk-item:not(.sk-out)');if(a)v[a.getAttribute('href')]=1}});return v}
  function next(vis){if(!pool.length)return null;for(var t=0;t<pool.length*2;t++){if(!queue.length)queue=shuffle(pool.slice());var p=queue.pop();if(!vis[p.getAttribute('href')])return p}return null}
  function put(i,animate){
    var c=cells[i],p=next(visible());if(!p)return false;
    var el=p.cloneNode(true),old=c.querySelector('.sk-item');
    if(animate&&old){
      el.classList.add('sk-pre');c.appendChild(el);
      requestAnimationFrame(function(){requestAnimationFrame(function(){el.classList.remove('sk-pre');old.classList.add('sk-out');setTimeout(function(){if(old.parentNode)old.parentNode.removeChild(old)},800)})});
    }else{c.appendChild(el)}
    return true;
  }
  free.forEach(function(i){if(!put(i,false)){box.removeChild(cells[i]);cells[i]=null}});
  free=free.filter(function(i){return cells[i]});
  var shown=cells.filter(Boolean).length;
  if(!shown){root.style.display='none';return}
  box.style.setProperty('--sk-cols',Math.max(1,Math.min(n,shown)));
  if(auto&&free.length&&pool.length>free.length){
    var paused=false;
    root.addEventListener('mouseenter',function(){paused=true});
    root.addEventListener('mouseleave',function(){paused=false});
    setInterval(function(){if(paused||document.hidden)return;free.forEach(function(i,k){setTimeout(function(){put(i,true)},k*250)})},iv);
  }
  root.classList.add('sk-ready');
}
function initRelated(root){
  if(root.getAttribute('data-sk-init'))return;root.setAttribute('data-sk-init','1');
  var mode=root.getAttribute('data-mode'),count=parseInt(root.getAttribute('data-count'),10)||4;
  var fixed=[].slice.call(root.querySelectorAll('.sk-card[data-kind=fixed]'));
  var pool=[].slice.call(root.querySelectorAll('.sk-card[data-kind=pool]'));
  var grid=root.querySelector('.sk-rel-grid');
  var have={};fixed.forEach(function(f){have[f.getAttribute('href')]=1;f.hidden=false});
  var need=mode==='manual'?0:(mode==='mixed'?Math.max(0,count-fixed.length):count);
  pool.forEach(function(p){p.hidden=true});
  shuffle(pool).filter(function(p){return !have[p.getAttribute('href')]}).slice(0,need).forEach(function(p){p.hidden=false;grid.appendChild(p)});
}
function run(ctx){
  [].forEach.call((ctx||document).querySelectorAll('.sk-root'),initShowcase);
  [].forEach.call((ctx||document).querySelectorAll('.sk-rel'),initRelated);
}
if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',function(){run()})}else{run()}
document.addEventListener('shopify:section:load',function(e){run(e.target)});
})();
